import React from 'react';
import { Print } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-unresolved
import { useReactToPrint } from 'react-to-print';
import ToolButton from '../../../../components/ToolButton';
import { MenuButtonStyle } from './styles';

interface Props {
  printRef: React.RefObject<HTMLDivElement>;
}

const PrintDashboard = ({ printRef }: Props) => {
  const { t } = useTranslation();

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: 'hospitality-dashboard',
  });

  return (
    <ToolButton
      buttonStyle={{
        ...MenuButtonStyle,
        color: 'text.secondary',
        backgroundColor: 'background.paper',
      }}
      hideTextOnMobileView={false}
      iconElement={<Print />}
      onClick={handlePrint}
      text={t('screens.dashboarding.print')}
      tooltip={t('screens.dashboarding.print')}
      active={false}
    />
  );
};

export default PrintDashboard;
